import { app } from '../../app.module'
app
  // アカウント詳細モーダル
  .directive('accountDetailModal', () => {
    return {
      restrict: 'A',
      controller: (
        $rootScope,
        $scope,
        $mdDialog,
        AccountDetailModalService,
        RestangularService
      ) => {
        // アカウントの基本データを取得
        const endpoint = '/account/getAccountById'
        const params = {
          account_id: $scope.accountId,
          sns_type: $scope.snsType,
          group_id: $rootScope.groupId,
          user_id: $rootScope.userId,
        }

        RestangularService.request('GET', endpoint, params).then((result) => {
          $scope.accountInfo = AccountDetailModalService.Data.setAccountBasicData(
            $scope.snsType,
            result[0].data[0]
          )
          $scope.memoCount = $scope.accountInfo.memoCount ? $scope.accountInfo.memoCount : 0
        })

        // アカウント基本データをセット

        $scope.changeStateView = function (stateView) {
          $scope.stateView = stateView
        }

        // メモ数が変更されるイベント
        $scope.$on('changeMemo', (event, changeInfo) => {
          switch (changeInfo.type) {
            case 'add':
              $scope.memoCount = $scope.memoCount + 1
              break
            case 'delete':
              $scope.memoCount = $scope.memoCount - 1
              break
          }
        })

        /**
         * モーダルを閉じる処理
         */
        $scope.close = function () {
          $mdDialog.hide()
        }
      },
    }
  })
